<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div  v-show="stateArrow" id="leftBox" class="leftBox" style="width: 206px">
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <el-scrollbar>
              <tree
                :isSearch="isSearch"
                @initFun="initQuery"
                @nodeClick="nodeClick"
              ></tree>
            </el-scrollbar>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"></i>
        </div>
      </div>
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
               <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane :label="$t('common.pendingOrder')" name="first">
                        <RepairForm ref='TabRepair' @cellClick="cellClick"></RepairForm>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('common.myOrderAcceptance')" name="second">
                        <RepairOrder ref='TabMaintenance'></RepairOrder>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('TopBar.handle')" name="third">
                        <Processed ref='process'></Processed>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('VehicleManagement.closed')" name="four">
                        <Closed ref='close'></Closed>
                    </el-tab-pane>
                </el-tabs> 
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MaintainManagement from "./MaintainManagement.js";
export default MaintainManagement;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>

